import { componentQrl, inlinedQrl, _jsxC, _fnSignal, _IMMUTABLE } from "@builder.io/qwik";
import { DynamicRenderer } from "../../components/dynamic-renderer/dynamic-renderer.qwik.mjs";
import { getClassPropName } from "../../functions/get-class-prop-name.qwik.mjs";
const attrs = function attrs2(props, state) {
  return {
    ...props.attributes,
    [getClassPropName()]: `${props.link ? "" : "builder-button"} ${props.attributes[getClassPropName()] || ""}`,
    ...props.link ? {
      href: props.link,
      target: props.openLinkInNewTab ? "_blank" : void 0,
      role: "link"
    } : {
      role: "button"
    }
  };
};
const Button = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxC(DynamicRenderer, {
    attributes: attrs(props),
    get TagName() {
      return props.link ? props.builderLinkComponent || "a" : "button";
    },
    actionAttributes: {},
    children: _fnSignal((p0) => p0.text, [
      props
    ], "p0.text"),
    [_IMMUTABLE]: {
      TagName: _fnSignal((p0) => p0.link ? p0.builderLinkComponent || "a" : "button", [
        props
      ], 'p0.link?p0.builderLinkComponent||"a":"button"'),
      actionAttributes: _IMMUTABLE
    }
  }, 3, "jc_0");
}, "Button_component_gJoMUICXoUQ"));
export {
  Button,
  attrs,
  Button as default
};
